var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewDoc(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 1.667h8.334a2.5 2.5 0 012.5 2.5v11.666a2.5 2.5 0 01-2.5 2.5H5.833a2.5 2.5 0 01-2.5-2.5V4.167a2.5 2.5 0 012.5-2.5zm0 1.666A.833.833 0 005 4.167v11.666a.833.833 0 00.833.834h8.334a.833.833 0 00.833-.834V4.167a.833.833 0 00-.833-.834H5.833zm1.667.834h5a.833.833 0 010 1.666h-5a.833.833 0 110-1.666zm0 10h1.667a.833.833 0 110 1.666H7.5a.833.833 0 110-1.666zm0-3.334h5a.833.833 0 010 1.667h-5a.833.833 0 110-1.667zm0-3.333h5a.833.833 0 010 1.667h-5a.833.833 0 110-1.667z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDoc);
export default ForwardRef;